import React, { FC } from 'react';

import { LanguageScope, useLanguages } from '../../shop/language/useLanguages';
import { LoanFormat, mapLoanFormat } from '../../../models/LoanFormat';
import { useParams } from 'react-router';
import { getLoanFormat } from '../utils/getLoanFormat';
import { useAgeCategorySearchParam } from '../utils/useAgeCategorySearchParam';
import ShopLanguageDropDown from './ShopLanguageDropDown';
import TitleDropdown from './TitleDropdown';
import {
    LOANFORMAT_EAUDIOBOOK_OBJECT,
    LOANFORMAT_EBOOK_OBJECT,
    LOANFORMAT_EPRESS_OBJECT
} from '../loanFormat/constants';
import LanguageDropDown from '../../shop/language/navigation/LanguageDropDown';
import RoutingUtils from '../utils/utils-routing';
import SubNavigationLayout from './SubNavigationLayout';
import styled from 'styled-components';
import AgeCategorySelector from '../common/AgeCategorySelector';
import { useTranslation } from 'react-i18next';

const StAgeCategorySelector = styled(AgeCategorySelector)`
    margin-left: 10px;
`;

const StDropDownContainer = styled.div`
    display: flex;
`;

type Props = {
    readonly isSticky: boolean;
    readonly shopLanguage?: string;
    readonly loanFormat: typeof LoanFormat.eAudiobooks | typeof LoanFormat.eBooks | typeof LoanFormat.ePress;
};

const LanguageProductsNavigation: FC<Props> = ({ isSticky, shopLanguage, loanFormat }) => {
    const { t } = useTranslation();
    const { languageId: selectedLanguage = '' } = useParams<'languageId'>();
    const { value: ageCategory } = useAgeCategorySearchParam();

    const loanFormatState = getLoanFormat(loanFormat);
    const { languages } = useLanguages({
        scope: LanguageScope.LANGUAGES,
        loanFormat: mapLoanFormat(loanFormatState.requestKey),
        ageCategory,
        shopLanguage
    });

    return (
        <SubNavigationLayout
            left={
                <StDropDownContainer>
                    {shopLanguage ? <ShopLanguageDropDown currentShopLanguage={shopLanguage} /> : null}
                    <TitleDropdown
                        loanFormat={
                            loanFormat === LoanFormat.eAudiobooks
                                ? LOANFORMAT_EAUDIOBOOK_OBJECT
                                : loanFormat === LoanFormat.eBooks
                                ? LOANFORMAT_EBOOK_OBJECT
                                : LOANFORMAT_EPRESS_OBJECT
                        }
                        shopLanguage={shopLanguage}
                    />
                </StDropDownContainer>
            }
            center={
                <LanguageDropDown
                    languages={languages}
                    selectedLanguage={selectedLanguage}
                    label={t(`filters:language.${selectedLanguage}`, selectedLanguage)}
                    itemTargetBuilder={({ language, isMultiLanguageShopEnabled, ageCategorySearchParam }) =>
                        RoutingUtils.languagesPageLocationDescriptor({
                            loanFormat: loanFormatState.urlKey,
                            language: language.name,
                            shopLanguage,
                            isMultiLanguageShopEnabled,
                            ageCategory: ageCategorySearchParam
                        })
                    }
                />
            }
            right={
                !isSticky ? (
                    <StDropDownContainer>
                        <StAgeCategorySelector />
                    </StDropDownContainer>
                ) : null
            }
            isSticky={isSticky}
            width="35"
        />
    );
};

export default LanguageProductsNavigation;
